import { render } from "./Create.vue?vue&type=template&id=992e8cd6"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/mwon.net/gugar.mwon.net/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__